import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Option } from 'common/components/select/select.component';
import { AccountAdminEligibilityCriteriaService } from 'src/private/app/services/account-admin/account-admin-eligibility-criteria.service';
import { QueryBuilderConfig, RuleSet, Rule } from 'common/libs/angular2-query-builder/query-builder/query-builder.interfaces';
export enum ToggleType {
    And = 'and',
    Or = 'or'
}

@Component({
    selector: 'hvac-dynamic-nested-filter',
    templateUrl: './dynamic-nested-filter.component.html',
    styleUrls: ['./dynamic-nested-filter.component.scss']
})
export class DynamicNestedFilterComponent implements OnChanges {
    @Input() QueryBuilderConfigData: QueryBuilderConfig;
    @Input() QueryData: RuleSet;
    @Output() updatedQueryData = new EventEmitter<RuleSet>();

    public config: QueryBuilderConfig;
    public query: RuleSet;
    public toggleTypeOr: string = ToggleType.Or;
    public programNameForm: UntypedFormGroup = new UntypedFormGroup({ programName: new UntypedFormControl('') });

    constructor(
        public eligibilityCriteriaService: AccountAdminEligibilityCriteriaService
    ) {
        this.config = { fields: {} };
    }

    ngOnChanges() {
        this.config = this.QueryBuilderConfigData;
        this.query = this.QueryData;
    }

    onFieldChange(fieldValue: string, rule: Rule) {
        rule.value = '';
        if (fieldValue === 'ProgramId') {
            this.programNameForm.controls.programName.setValue('');
        }
    }

    onChanges($event: Option, rule: Rule) {
        if (rule.field === 'ProgramId') {
            rule.value = String($event.value);
        }

        return rule;
    }

    onQueryBuilderChange($event: RuleSet) {
        this.updatedQueryData.emit($event);
        const deleteButtonSelector = document.querySelector('.query-builder-delete-button');
        deleteButtonSelector?.setAttribute('style', 'display: none');
    }
}
